export enum recruiterUpdateAllStatusTypes {
    FETCH_RECRUITER_UPDATE_ALL_STATUS_REQUEST = "FETCH_RECRUITER_UPDATE_ALL_STATUS_REQUEST",
    FETCH_RECRUITER_UPDATE_ALL_STATUS_SUCCESS = "FETCH_RECRUITER_UPDATE_ALL_STATUS_SUCCESS",
    FETCH_RECRUITER_UPDATE_ALL_STATUS_FAILURE = "FETCH_RECRUITER_UPDATE_ALL_STATUS_FAILURE",
  }